import * as React from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import Page from "./layout/Page";
import Products from "./product/Products";
import Media from "./media";
// import Translations from "./translations";

import "~/components/main.css";
import CollectionOverview from "./collection";
import CollectionEditor from "./collection/CollectionEditor";
export interface Props
{
    
}

interface State
{
    
}

// const CenterLayer = styled(Layer)`
//     display: flex;
//     justify-content: center;
// `;

class Main extends React.Component<Props & RouteComponentProps<any>, State>
{
    render()
    {
        return (
            <Page {...this.props} >
                <Route path="(/products|/)" component={Products} />
                <Route path="/media/:parentId?" component={Media} />
                {/*<Route path="/translations/:language?" component={Translations} />*/}
                <Route path="/collections/" exact component={CollectionOverview} />
                <Route path="/collections/:collectionId" exact component={CollectionEditor} />
            </Page>
        );
        
    }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.tsx